import {
  getAccountsUrl,
  getCrmUrl,
  getInsightsUrl,
  getPerspectiveUrl,
  getUnisonUrl,
} from '@/api/urls';
import { PLATFORMS } from '@/constants/platforms';
import { usePath } from '@/hooks/usePath';
import Panel from '@/components/Panel';
import PlatformCard from '@/components/PlatformCard';
import TextLink from '@/components/TextLink';
import type { Platform } from './types';
import { ICONS } from './constants';
import { classes, PLATFORM_META } from './utils';

export type PlatformSelectorProps = {
  onBack: () => void;
};

export default function PlatformSelector({ onBack }: PlatformSelectorProps) {
  const { navigate } = usePath();

  const handleSelectPlatform = (platform: Platform) => {
    switch (platform) {
      case PLATFORMS.CRM:
        return navigate(getCrmUrl());
      case PLATFORMS.PERSPECTIVE:
        return navigate(getPerspectiveUrl());
      case PLATFORMS.SETTINGS:
        return navigate(getAccountsUrl());
      case PLATFORMS.INSIGHTS:
        return navigate(getInsightsUrl());
      case PLATFORMS.UNISON:
        return navigate(getUnisonUrl());
      default:
        throw Error(`Unrecognized platform: ${platform}`);
    }
  };

  return (
    <Panel className={classes.panel} side="right">
      <div className={classes.label}>Select a Platform</div>
      <div className={classes.list}>
        {PLATFORM_META.map((platform) => (
          <PlatformCard
            key={platform.id}
            description={platform.description}
            icon={ICONS[platform.id]}
            tileClassName={platform.tileClass}
            title={platform.title}
            onClick={() => handleSelectPlatform(platform.id)}
          />
        ))}
      </div>
      <div className={classes.spacer} />
      <div className={classes.footer}>
        <TextLink onClick={onBack}>Back</TextLink>
      </div>
    </Panel>
  );
}
